import { fetchWithCache, getCachedData } from "../services/apiService";

export const leasedProperties = async ({ setProperties }) => {
  // Show cached data immediately if available
  const cached = getCachedData("/api/property/propertyLeased", {});
  if (cached) {
    setProperties(cached);
  }

  try {
    const data = await fetchWithCache(
      "/api/property/propertyLeased",
      {
        method: "GET",
        retries: 2,
        timeout: 10000,
      },
      true,
    );
    setProperties(Array.isArray(data) ? data : []);
  } catch (error) {
    if (!cached) {
      setProperties([]);
    }
  }
};
